class Employee {
	constructor(
		id,
		slug,
		name,
		bio,
		calibre,
		salary,
		initialLevel,
		jobType,
		jobTitle,
		jobDescription
	) {
		this.id = id;
		this.slug = slug;
		this.name = name;
		this.bio = bio;
		this.calibre = calibre;
		this.salary = salary;
		this.initialLevel = initialLevel;
		this.jobType = jobType;
		this.jobTitle = jobTitle;
		this.jobDescription = jobDescription;
	}
	
	toPlainObj() {
		return {
			id: this.id,
			slug: this.slug,
			name: this.name,
			bio: this.bio,
			calibre: this.calibre,
			salary: this.salary,
			initialLevel: this.initialLevel,
			jobType: this.jobType,
			jobTitle: this.jobTitle,
			jobDescription: this.jobDescription
		};
	}
}

export default function EmployeeBuilder() {
	return {
		withId: function (id) {
			this.id = id;
			return this;
		},
		withSlug: function (slug) {
			this.slug = slug;
			return this;
		},
		withName: function(name) {
			this.name = name;
			return this;
		},
		withBio: function(bio) {
			this.bio = bio;
			return this;
		},
		withCalibre: function(calibre) {
			this.calibre = calibre;
			return this;
		},
		withSalary: function(salary) {
			this.salary = salary;
			return this;
		},
		withInitialLevel: function(initialLevel) {
			this.initialLevel = initialLevel;
			return this;
		},
		withJobType: function(jobType) {
			this.jobType = jobType;
			return this;
		},
		withJobTitle: function(jobTitle) {
			this.jobTitle = jobTitle;
			return this;
		},
		withJobDescription: function(jobDescription) {
			this.jobDescription = jobDescription;
			return this;
		},
		build: function () {
			return new Employee(
				this.id, 
				this.slug, 
				this.name, 
				this.bio, 
				this.calibre, 
				this.salary, 
				this.initialLevel,
				this.jobType, 
				this.jobTitle, 
				this.jobDescription
			);
		}
	};
}
